import React from "react";
import Dashboard from "../../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";
import RecordSearchReport from "../../@Components/Products/RecordSearchReport";

const RecordSearch: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <RecordSearchReport />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default RecordSearch;
